import { useState } from "react";
import { useTranslations } from "next-intl";
import LandingSignUp from "@/widgets/landing/ui/LandingSignUp";
import LandingSignIn from "@/widgets/landing/ui/LandingSignIn";

const LandingAuthForm = () => {
  const t = useTranslations("Auth");
  const [selectedForm, setSelectedForm] = useState<"sign-up" | "sign-in">(
    "sign-up"
  );

  return (
    <div
      className={
        "w-[504px] max-w-full rounded-br-md rounded-tl-md rounded-tr-md border border-primary-dark bg-white p-[20px]"
      }
    >
      <div className={"flex h-[60px] gap-[8px] rounded-md bg-gray-100 p-[6px]"}>
        <button
          onClick={() => setSelectedForm("sign-up")}
          className={`${selectedForm === "sign-up" ? "bg-white text-gray-800" : "bg-transparent text-gray-500"} flex w-1/2 items-center justify-center rounded-md text-title2 font-[600]`}
        >
          {t("회원가입")}
        </button>
        <button
          onClick={() => setSelectedForm("sign-in")}
          className={`${selectedForm === "sign-in" ? "bg-white text-gray-800" : "bg-transparent text-gray-500"} flex w-1/2 items-center justify-center rounded-md text-title2 font-[600]`}
        >
          {t("로그인")}
        </button>
      </div>
      <div className={"mt-[50px]"}>
        {selectedForm === "sign-up" && <LandingSignUp />}
        {selectedForm === "sign-in" && <LandingSignIn />}
      </div>
    </div>
  );
};
export default LandingAuthForm;
